import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import Loader from 'react-loader-spinner'

import TextAreaComment from '../../atoms/textAreaComment/textAreaComment'
import CommentsSection from '../../atoms/commentsSection/commentsSection'

import test from '../../../assets/images/test.png'

import { competitionId } from '../../../constants/activity-constants'
import ForumServices from '../../../services/forumServices'
import userSessionStorage from '../../../utils/userSessionStorage'
import * as Utils from '../../../utils/utilsCampaign'

import './zonaVirtual.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ZonaVirtual = ({ isMobile, isIos }) => {
  const session = new userSessionStorage()

  const [commentContent, setCommentContent] = useState('')

  // Servicios de comentarios
  const [activeIndex, setActiveIndex] = useState(0)
  const [questions, setQuestions] = useState([])
  const [commentaries, setCommentaries] = useState([])
  const [commetsLoading, setCommetsLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(2)

  useEffect(() => {
    isMobile ? setSize(1) : setSize(2)
  }, [isMobile])

  const getConfig = () => {
    let tokenId = session.getToken() ? session.getToken().idToken : null
    return {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
  }

  const getComments = async initial => {
    setCommetsLoading(true)
    try {
      ForumServices.getRepliesByForum(
        initial ? parseInt(initial) : questions[activeIndex].forumId,
        page,
        size
      ).then(resp => {
        resp.data ? setCommentaries(resp.data) : setCommentaries([])
        setCommetsLoading(false)
      })
    } catch (error) {
      console.log(`error--->`, error)
      setCommetsLoading(false)
    }
  }

  const postReply = async load => {
    setButtonLoading(true)
    const config = getConfig()
    try {
      ForumServices.saveForumReply(
        questions[activeIndex].forumId,
        commentContent,
        config
      ).then(resp => {
        setButtonLoading(false)
        setCommentContent('')
      })
    } catch (error) {
      setButtonLoading(false)
      console.log(error)
    }
    getComments(false)
  }

  useEffect(() => {
    ForumServices.getForumByConcourseId(competitionId.tasks)
      .then(res => {
        setQuestions(res.data)
        getComments(res.data[0].forumId)
      })
      .catch(e => console.log(e))
  }, [size])

  return (
    <div className={`f-zonaVirtual-container ${isIos && 'propsIos'}`}>
      <div id="zona-virtual" className="f-zonaVirtual-container__ancla" />
      <div className="f-zonaVirtual-container__content">
        <div className="f-zonaVirtual-container__content__contentQuestion">
          {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
            <p>
              Este espacio es para vos. Contanos ¿Cómo es tu menstruación?
              Inesperada, inolvidable, impredecible, incómoda, deseada, o a
              veces… ¿indecisa?
            </p>
          ) : (
            <p>
              Este espacio es para ti. Cuéntanos, ¿cómo ha sido tu menstruación?
              Inesperada, inolvidable, impredecible, incómoda, deseada, o tal
              vez… ¿indecisa?
            </p>
          )}

          <h2>Tema: Tu menstruación tiene una historia</h2>
          <TextAreaComment
            colorError='pink'
            max={500}
            setContent={setCommentContent}
            action={() => {
              if (commentContent.length > 0) {
                postReply(true)
              }
            }}
            buttonLoading={buttonLoading}
          />
        </div>
        {commetsLoading ? (
          <div className="loader">
            <Loader type="TailSpin" color="#f01076" height={150} width={150} />
          </div>
        ) : (
          commentaries.map((comment, index) => {
            return (
              <CommentsSection
                key={index}
                author={comment.userFullName}
                date={Utils.formatDate(comment.replyDate)}
                profilePhoto={comment.profilePhoto}
                likesComment={comment.score}
                comment={comment.comment}
                idComment={comment.forumReplyId}
                isMobile={isMobile}
                config={getConfig()}
              />
            )
          })
        )}

        <Link
          className="f-zonaVirtual-container__content__verMas"
          to="/zonaVirtual"
          onClick={() =>
            pushEventDataLayer(
              'Interacciones - historias',
              'Cur-v',
              'Click',
              'Ver más historias'
            )
          }
        >
          Ver más historias
        </Link>
      </div>
    </div>
  )
}

export default ZonaVirtual
